import LayoutPage from "../../Components/LayoutPage"
import EditAdminContainer from "./Components/EditAdminContainer"

export default function AdminInfo() {
  return (
    <LayoutPage activeIndex={15} navItems={["مدیران سامانه", "مدیر ۹۷۱۶۸۲"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto">
      <EditAdminContainer />
    </LayoutPage>
  )
}